import moment from "moment";
import LobConstants from "../constants/LobConstants";
import serverCredintials from "../constants/serverCredintials";
import { default as PortTariffServices } from "./services/InvoiceMasterServices";
import { default as MasterServices } from "./services/MasterServices";
import { default as JobTrackingServices } from "./services/JobTrackingServices";
import { default as frontLineServices } from "./services/frontlineServices";
import { default as dmsFileService } from "./services/DMSFileService";

const SERVICE_URL = serverCredintials.BuildURL.getServiceURL();
const MASTER_SERVICE_URL = serverCredintials.BuildURL.getMasterServiceURL();
const PORT_SERVICE_URL = serverCredintials.BuildURL.getPortServiceURL();
const EMAIL_SERVICE = serverCredintials.BuildURL.getEmailServiceEndpoint();
const SAP_CONNECTION_DETAILS =
  serverCredintials.BuildURL.getSapServiceEndpointConfig();
const FRONTLINE_SERVICE_URL =
  serverCredintials.BuildURL.getFrontLineServiceURL();

const CONFIG_HEADERS = {
  // token: "",
  // user_email: " ",
};

// const SAP_CONFIG_HEADERS = {
//   userid: 1,
//   token: "",
// };

export async function listOfAllQuotations(queryparams = null) {
  return await frontLineServices.PDAList(
    SERVICE_URL + "/job/listAllQuotations",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getTrackingDetailsByjobCode(queryparams = null) {
  return await JobTrackingServices.getJobTrackingDetails(
    SERVICE_URL + "/trackShipment",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getTrackingDetailsByByPO(queryparams = null) {
  return await JobTrackingServices.getJobTrackingDetails(
    SERVICE_URL + "/trackShipmentByPO",
    queryparams,
    CONFIG_HEADERS
  );
}


export async function getDataBasedOnRefresh(queryparams = null) {
  return await frontLineServices.BaseRFQList(
    SERVICE_URL + "/job/jobServices",
    queryparams,
    CONFIG_HEADERS
  );
}




export default {
 getTrackingDetailsByjobCode,
 getTrackingDetailsByByPO
}
